import { Descriptions, Form, Select, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { getFormattedDate } from 'modules/utilities/utility';
const { Text } = Typography;

const SelectOrder = ({ orders, setSelectedOrder, setTicketPayload, setSlotBookingPayload, setValidation }) => {
    useEffect(() => {
        setValidation(prevValidation => ({ ...prevValidation, order_display_id: false }));
    }, [])
    const [orderDescription, setOrderDescription] = useState({})


    const orderOptions = orders?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map((order) => ({ key: order?.order_display_id, value: order?.order_display_id }))


    const onOrderSelect = (orderId) => {
        const orderToSelect = orders.find(order => order.order_display_id === orderId);
        setSelectedOrder(orderToSelect);
        setValidation(prevValidation => ({ ...prevValidation, order_display_id: true }));
        let orderStatus = '';
        if (orderToSelect?.sub_status) { orderStatus = orderToSelect?.sub_status.replace('_', ' ') }
        else { orderStatus = orderToSelect?.status.replace('_', ' ') }
        if (orderToSelect.delivery_date && orderToSelect.sub_status === 'delivered') { orderStatus = orderStatus + ' | ' + getFormattedDate(orderToSelect.delivery_date) }

        const sourceMeta = {
            title: "create_ticket",
            order_display_id: orderToSelect.order_display_id,
            order_id: orderToSelect.id,
            order_details: `Customer Name: ${orderToSelect.order_meta.shipping_address.name} \n\Order ID: ${orderToSelect?.order_display_id}\n\Order Date: ${getFormattedDate(orderToSelect?.ordered_date)}\n\Order Amount: ${orderToSelect?.order_meta.total_price}`,
        }

        setSlotBookingPayload(prevPayload => ({ ...prevPayload, caseId: orderToSelect.case_id }))

        setTicketPayload(prevPayload => ({ ...prevPayload, case_id: orderToSelect.case_id, source_meta: sourceMeta, provider_meta: { subject: `${orderToSelect?.order_display_id} | ${orderToSelect.order_meta.shipping_address?.first_name} : }` } }))

        const items = [
            { key: '1', label: 'Name', children: orderToSelect.order_meta.shipping_address.name },
            { key: '2', label: 'Order display Id', children: orderToSelect?.order_display_id },
            { key: '3', label: 'Order Date', children: getFormattedDate(orderToSelect?.created_at) },
            { key: '4', label: 'Amount', children: orderToSelect?.order_meta.total_price },
            { key: '5', label: 'Delivery status', children: <span className='text-capitalize'>{orderStatus}</span> }
        ];
        setOrderDescription(items);
    }
    return (
        <div>
           <Space.Compact block className='my-3'>
            <span
                style={{
                background: '#FAFAFA',
                border: '#D9D9D9',
                width: '30%',
                }}
                className='border border-1 border-end-0 d-flex justify-content-start align-items-center rounded-start px-2'
            >
                <Text>Select Order</Text>
            </span>

            <Select
                style={{ width: '70%' }}
                showSearch
                placeholder={
                _.size(orders) < 1
                    ? 'No order available, try searching'
                    : 'Select the order'
                }
                onSelect={onOrderSelect}
                options={orderOptions || []}
            />
            </Space.Compact>

            {Object.keys(orderDescription).length > 0 && <Form.Item>
                <div className='m-2 border border-1 rounded-4 p-2'>
                    <Descriptions title="Order Details" layout="vertical" items={orderDescription} />
                </div>

            </Form.Item>}

        </div>
    )
}

export default SelectOrder